/* Mobile only: hide the product gallery thumbnail strip once the
   user scrolls to engage with the personalization area, reveal it
   when scrolling back up toward the gallery. Frees vertical space
   for the personalization fields below the sticky gallery wrapper.

   Trigger: position of the personalization root in the viewport.
   - Customall: .ctm-customize-product
   - Customily: #cl_optionsapp

   Two kinds of thumbnail strip are handled:
   - Customily / non-Customall: the THEME gallery
     <media-gallery> <slider-component class="thumbnail-slider">.
   - Customall: the app's OWN Embla thumbnail carousel
     <div class="embla embla--thumb thumb-carousel"> inside
     #artwork-preview. (The theme <media-gallery> is hidden on Customall
     by customall-v2.css, so the old script — which only knew about the
     theme slider — had nothing visible to hide. This v2 adds .embla--thumb.)

   Anti-jump: instant display:none (no CSS transition). Browser's
   built-in scroll anchoring (overflow-anchor: auto) keeps visible
   content stable when the sticky wrapper shrinks. */
(function () {
  if (!window.matchMedia('(max-width: 749px)').matches) return;

  function injectStyles() {
    if (document.getElementById('thumb-autohide-style')) return;
    var s = document.createElement('style');
    s.id = 'thumb-autohide-style';
    s.textContent =
      '@media (max-width: 749px) {' +
      '  body { overflow-anchor: auto; }' +
      '  media-gallery slider-component[id^="GalleryThumbnails"].thumbs-autohidden,' +
      '  #artwork-preview ~ media-gallery slider-component[id^="GalleryThumbnails"].thumbs-autohidden,' +
      '  #artwork-preview .embla--thumb.thumbs-autohidden,' +
      '  .embla--thumb.thumbs-autohidden {' +
      '    display: none !important;' +
      '  }' +
      '}';
    document.head.appendChild(s);
  }

  function bind(thumbsList, personalization) {
    var hidden = false;
    var HIDE_AT = 400;
    var SHOW_AT = 550;

    function hide() {
      if (hidden) return;
      thumbsList.forEach(function (t) { t.classList.add('thumbs-autohidden'); });
      hidden = true;
    }
    function show() {
      if (!hidden) return;
      thumbsList.forEach(function (t) { t.classList.remove('thumbs-autohidden'); });
      hidden = false;
    }

    var ticking = false;
    function check() {
      ticking = false;
      var top = personalization.getBoundingClientRect().top;
      if (!hidden && top < HIDE_AT) hide();
      else if (hidden && top > SHOW_AT) show();
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(check);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    check();
  }

  function init() {
    injectStyles();
    var attempts = 0;
    var iv = setInterval(function () {
      attempts++;
      var thumbsList = [];
      var themeThumbs = document.querySelector('media-gallery slider-component.thumbnail-slider');
      var emblaThumbs = document.querySelector('#artwork-preview .embla--thumb, .embla--thumb');
      if (themeThumbs) thumbsList.push(themeThumbs);
      if (emblaThumbs) thumbsList.push(emblaThumbs);
      var personalization = document.querySelector('.ctm-customize-product, #cl_optionsapp');
      if (thumbsList.length && personalization) {
        clearInterval(iv);
        bind(thumbsList, personalization);
      } else if (attempts > 60) {
        clearInterval(iv);
      }
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
